import {Component, HostBinding, Inject, LOCALE_ID, OnInit, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {timestampToFullDateTime} from '../../utility/timestamp-functions';
import {AuthorizationService} from '../../authorization/authorization.service';
import {SatPopover} from '@ncstate/sat-popover';
import {
  EndUserExtendedRegistrationService
} from '../../end-user/end-user-list/actions/end-user-extended-registration/end-user-extended-registration.service';

@Component({
  selector: 'app-end-user-confirmation-info',
  templateUrl: './end-user-confirmation-info.component.html',
})
export class EndUserConfirmationInfoComponent implements OnInit {
  @ViewChild(SatPopover) popover: SatPopover;
  @HostBinding('class.header-menu-item') endUserConfirmationInfo = true;
  protected readonly timestampToFullDateTime = timestampToFullDateTime;

  constructor(
    public http: HttpClient,
    public router: Router,
    public endUserExtendedRegistrationService: EndUserExtendedRegistrationService,
    private authorizationService: AuthorizationService,
    @Inject('ENVIRONMENT_VERSION') protected environmentVersion: string,
    @Inject('ENVIRONMENT_API_BASEPOINT') protected environmentApiBasepoint: string,
    @Inject(LOCALE_ID) protected localeId: string
  ) {
  }

  ngOnInit() {
    this.endUserExtendedRegistrationService.startRefresh();
  }

  endUserRouterLink(endUserId: number) {
    const route = this.authorizationService.moderatorToken === null
      ? '/end-user/end-user-list/' + endUserId + '/profile'
      : '/end-user/end-user-list/' + endUserId + '/extended-registration';
    this.router.navigate([route]);
    this.endUserExtendedRegistrationService.updateEndUserExtendedRegistrationEvent.next(true);
    this.popover.close();
  }
}
